import { useEffect, useState } from 'react';
import type { SxProps, Theme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { isValid } from 'date-fns';
import { formatBirthday, parseBirthday } from '../utils/birthday';

const EARLIEST = new Date(1900, 0, 1);

export function BirthdayField({ value, onChange, helperText, fullWidth, sx }: {
  value: string;
  onChange: (value: string) => void;
  helperText?: string;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}) {
  // Held locally so a half-typed (invalid) date stays on screen instead of being wiped by the parent.
  const [date, setDate] = useState<Date | null>(() => parseBirthday(value));
  useEffect(() => {
    if ((date && isValid(date) ? formatBirthday(date) : '') !== value) setDate(parseBirthday(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- re-sync only when the parent's value changes
  }, [value]);

  return (
    <DatePicker
      label="Birthday"
      format="dd/MM/yyyy"
      value={date}
      onChange={(next: Date | null) => {
        setDate(next);
        if (next === null) onChange('');
        else if (isValid(next)) onChange(formatBirthday(next));
      }}
      disableFuture
      minDate={EARLIEST}
      slotProps={{
        textField: { size: 'small', helperText, fullWidth, sx },
        field: { clearable: true },
      }}
    />
  );
}
